// extracted by mini-css-extract-plugin
export default {"panel":"popup_panel__HMXhO","overlay":"popup_overlay__9H8AR","close":"popup_close__bi7w8"};